export default "__VITE_ASSET__BOzpn5_J__"